import { defineComponent as _defineComponent } from 'vue'
import CountrySwitcherModal from '@/features/buybox/components/CountrySwitcherModal.vue';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper-vfm';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxCountrySwitcher',
  props: {
    hideText: { type: Boolean },
    additionalContexts: null
  },
  setup(__props: any) {

const props = __props as { hideText?: boolean; additionalContexts: SnowplowContext[] };

const { webLocale, countryEmoji } = useLanguageStore();



const openCountrySwitcherModal = () => {
	ModalHelper.openModal(CountrySwitcherModal, { closable: true });
	TrackingHelper.trackEvent('userinteraction', { action: 'country_selector_clicked' }, props.additionalContexts);
};

return { __sfc: true,webLocale, countryEmoji, props, openCountrySwitcherModal, faAngleDown }
}

})